export const imageNotFound = 'https://images.framesnet.com/kp/Image.aspx'